import { HighLightOptions } from 'frappe-gantt';

import { GanttSelectionState } from '../../store/atom';

import { Task } from '@/features/saveSite/types';
import { DataFile } from '@/features/siteTop/types';

/**
 * GanttSelectionStateをHighLightOptionsに変換する
 * @param input
 */
export const convertGanttSelectionToFrappeGantt = (
  input: GanttSelectionState | null,
  alBuiltDataFiles: DataFile[],
  allTasks: Task[]
): HighLightOptions => {
  //allBuiltDataFileにMeasurementDateがないものは1つでもある場合はエラー
  const isAllBuiltDataFilesHasMeasurementDate = alBuiltDataFiles.every(
    (dataFile) => dataFile.measurementDate
  );
  if (!isAllBuiltDataFilesHasMeasurementDate)
    throw new Error('MeasurementDateがないDataFileがあります');
  //high light dateの取得
  const highlight_date = input?.date?.dataFile.measurementDate;
  //選択可能の日付の取得
  const selectable_date = alBuiltDataFiles
    .map((dataFile) => dataFile.measurementDate)
    .filter((date) => date !== undefined) as string[];
  //high light crossの取得
  let crosses: string[] = input?.crosses?.map((c) => c.dataFile.measurementDate) as string[];
  crosses = crosses?.filter((cross) => cross !== undefined) as string[];
  //選択可能のcrossの取得
  const tasksWithDesignData = allTasks.filter((task) => task.dataFileId);
  const selectable_crosses_array = tasksWithDesignData.map((task) => {
    //該当タスクの期間が、selectable_dateをまたぐものを全て取得
    const crossesArray = alBuiltDataFiles
      .map((dataFile) => {
        const isCross =
          (dataFile.measurementDate as string) >= task.scheduledStartDate &&
          (dataFile.measurementDate as string) <= task.scheduledEndDate;
        if (isCross)
          return {
            taskId: task.id,
            date: dataFile.measurementDate,
          };
        return undefined;
      })
      .filter((cross) => cross !== undefined) as { taskId: number; date: string }[];
    return crossesArray;
  });
  //flatで二次元配列を一次元に変換し、また重複(task,measureMentのかけ合わせ)を削除
  const selectable_crosses = selectable_crosses_array
    .flat()
    .filter(
      (cross, index, self) =>
        index === self.findIndex((t) => t.taskId === cross.taskId && t.date === cross.date)
    );

  //選択済み
  const highlight_crosses =
    input?.crosses?.map((c) => ({
      taskId: c.task.id,
      date: c.dataFile.measurementDate as string,
    })) || [];
  return {
    highlight_date,
    selectable_date,
    highlight_crosses,
    selectable_crosses,
  };
};
